import Image from 'next/image'

type Props = {
  text: string
  onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  className?: string
  leftSideIconPath?: string
  rightSideIconPath?: string
}

export const BtnWithIcon = ({
  text,
  onClick,
  className,
  leftSideIconPath,
  rightSideIconPath,
}: Props): JSX.Element => {
  if (!className) {
    className = 'flex justify-center items-center lg:mt-[.5vw]'
  }

  return (
    <div className={className}>
      <a onClick={onClick}>
        <div className="flex justify-center items-center h-[8.1vw] lg:h-[4.2vw] bg-gradient-to-r from-primaryTo to-primaryFrom rounded-xl shadow-light lg:hover:opacity-80">
          <div className="flex justify-between items-center mx-[3vw] lg:mx-[2.2vw] w-full">
            {leftSideIconPath && (
              <Image
                className="flex m-[3vw]"
                src={leftSideIconPath}
                alt="left-side-icon"
                width="30"
                height="30"
              />
            )}
            <div className="w-full text-center">
              <div className="text-white">{text}</div>
            </div>
            {rightSideIconPath && (
              <Image
                className="flex m-[3vw]"
                src={rightSideIconPath}
                alt="left-side-icon"
                width="20"
                height="23"
              />
            )}
          </div>
        </div>
      </a>
    </div>
  )
}
